<template>
  <v-container>
    <v-alert outlined color="blue" class="rounded-lg mx-2 mb-0">
      <v-row>
        <v-col v-for="(col, i) in keys" :key="`col${i}`" cols="4" class="px-1">
          <v-row v-for="key in Object.keys(col)" :key="`col${i}_${key}`" no-gutters>
            <v-col class="text-left">
              <b v-html="key"></b> - {{col[key]}}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-alert>
  </v-container>
</template>

<script>
export default {
  name: "InfoField",
  data() {
    return{
      keys:{
        col1:{
          "F1": "Поиск (Активация и Поиск)",
          "Esc": "Выйти из поиска",
          "F2": "Перейти к списку пропусков/сбросить значение фильтра",
          "Ctrl": "Обновление списка пропусков",
          "F9":"Впустить/Выпустить"
        },
        col2:{
          "F3":"Разовые пропуска",
          "F4":"Временные пропуска",
          "F5":"Массовые пропуска",
          "F6":"Автомобильные разовые пропуска",
          "F7":"Автомобильные временные пропуска"
        },
        col3:{
          "&udarr;":"Переход между пропусками",
          "Пробел":"Раскрыть/Скрыть выбранный Массовый пропуск",
          "&xrarr;":"Перейти в массовый пропуск",
          "&xlarr;":"Выйти из массового пропуска"
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
